// extracted by mini-css-extract-plugin
module.exports = {"buttonDisabled":"Posts_buttonDisabled_3oLbs","checkbox-label":"Posts_checkbox-label_2EkNp","colReverse":"Posts_colReverse_1v-bd"};